import {Injectable} from '@angular/core'
import {type Observable, of, throwError} from 'rxjs'
import type {GalleryServiceAdapter} from '@uve-solutions/f-gallery/app'
import type {
  GalleryBulkDownloadParams,
  GalleryDeleteParams,
  GalleryItem,
  GalleryItemDetail,
  GalleryUpdateParams,
  GalleryUploadParams,
  GalleryUploadResult,
  GalleryVisibilityParams,
} from '@uve-solutions/f-gallery/models'

/* La galería de cart es de solo lectura (permisos a false en gallery.providers.ts): los métodos de
 * escritura no son alcanzables desde la UI, pero cumplen el contrato emitiendo fallo visible —
 * nunca EMPTY, que dejaría los diálogos de f-gallery con el spinner colgado.
 * Sin openPreviewModal/closePreviewModal a propósito: el preview inline de f-gallery vive en el
 * injector de la ruta (un ion-modal se instancia en el injector raíz y no ve GALLERY_DATA_ADAPTER)
 * y mantiene el deep-link ?fileId=. Mismo patrón que street. */
@Injectable({providedIn: 'root'})
export class CartGalleryServiceAdapter implements GalleryServiceAdapter {
  uploadItem(params: GalleryUploadParams): Observable<GalleryUploadResult> {
    return of({item: this.placeholderItem(params), success: false})
  }

  updateItem(_params: GalleryUpdateParams): Observable<GalleryItemDetail> {
    return throwError(() => new Error('La galería de cart es de solo lectura'))
  }

  deleteItems(_params: GalleryDeleteParams): Observable<boolean> {
    return of(false)
  }

  downloadItem(item: GalleryItem): void {
    window.open(item.url, '_blank')
  }

  downloadBulk(_params: GalleryBulkDownloadParams): void {}

  changeVisibility(_params: GalleryVisibilityParams): Observable<boolean> {
    return of(false)
  }

  onOpenPreview(_item: GalleryItem): void {}

  onNavigateToFolder(_folderId: number): void {}

  generateShareLink(item: GalleryItem): string {
    return item.url
  }

  private placeholderItem(params: GalleryUploadParams): GalleryItem {
    return {
      id: 0,
      name: params.name,
      url: '',
      urlThumbnail: null,
      type: params.file ? 'file' : 'folder',
      mimeType: '',
      creationDate: '',
      readOnly: true,
      visibility: params.visibility,
      path: '',
      entities: null,
      tags: [],
      coordX: null,
      coordY: null,
    }
  }
}
